import React, { useEffect } from 'react'
import Header2 from '../../layout/Header2'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { useLanguage } from '../../contexts/LanguageContext'
import { Link } from 'react-router-dom'
import ServicesBanner from '../../components/haseeb/ServicesBanner'
import BannerImg from '../../assets/images/bannners/WebDevelopment.webp'
import ImageBorderStyleRight from '../../components/haseeb/ImageBorderStyleRight'
import ImageBorderStyleLeft from '../../components/haseeb/ImageBorderStyleLeft'
import Img1 from '../../assets/images/web-development/Img1.webp'
import Img2 from '../../assets/images/web-development/Img2.webp'
import Img3 from '../../assets/images/web-development/Img3.webp'
import WebDev from '../../assets/images/web-development/WebDev.webp'
import { Col, Row } from 'reactstrap'
import { FaDotCircle } from 'react-icons/fa'
import { ChevronRight } from 'react-bootstrap-icons'
import MiddleBannerSecondary from '../../components/haseeb/MiddleBannerSecondary'

const WebDevelopment = () => {
    const { t } = useLanguage();
    
    useEffect(() => {
        window.scrollTo(0,0);
    },[])
    
    return (
    <>
    <HelmetProvider>
    <Helmet prioritizeSeoTags>
        <title>software development & digital marketing agency in Germany - IT Junction </title>
    </Helmet>
    </HelmetProvider>
    <Header2/>
    <ServicesBanner
    BannerImg={BannerImg}
    SubTitle={t('servicePages.webDevelopment.subtitle')}
    Title={t('servicePages.webDevelopment.title')}
    />
<section id='website-responsive' className="container-fluid px-0">
<div id='website-responsive'>
        <div className='container-fluid ps-lg-5 ps-4 py-lg-5 py-4'>
            <Row className=''>
                <Col lg='3' className='pb-5'>
                    <div className='pb-md-3 pb-lg-0 pb-3'>
                        <div className='d-flex align-items-center'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/healthcare-solutions' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.healthcareSolutions')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/branding/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.branding')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/graphic-designing' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.graphicDesigning')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/content-writing/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.contentWriting')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/web-development/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-24 text-mulish fw-500 text-ss-primary'>
                                    {t('services.webDevelopment')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/app-development/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.appDevelopment')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/search-engine-optimization/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                    {t('services.seo')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/social-media-marketing/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                {t('services.socialMediaMarketing')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/video-animation/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                {t('services.videoAnimation')}
                            </span>
                                </Link>
                        </div>
                        <div className='d-flex align-items-center mt-3'>
                            <FaDotCircle className='text-ss-primary me-3'/>
                                <Link to='/services/ppc-marketing/' className='' style={{ textDecoration:'none', cursor:'pointer'}}>
                            <span className='fs-ss-18 text-mulish fw-500 text-ss-black'>
                                {t('services.ppcMarketing')}
                            </span>
                                </Link>
                        </div>
                    </div>
                </Col>
                <Col className='ps-lg-4 d-none d-lg-block'>
                        <div className='d-block d-lg-flex align-items-start'>
                          <div className='w-75'>
                          <div className='mb-lg-4 mb-3'>
                            <h2 className='fs-ss-36 text-philos fw-800 text-ss-black'>
                            {t('servicePages.webDevelopment.powerfulSolutionsTitle')}
                            </h2>
                        </div>
                            <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
                            {t('servicePages.webDevelopment.powerfulSolutionsDescription')}
                            </p>
                            </div>
                            <div className='px-lg-5'>
                            <img className='' src={WebDev} alt="Web Dev" style={{width:"400px"}} />
                        </div>
                    </div>
                </Col>

                <Col className='d-block d-lg-none'>
                          <div className='mb-lg-4 mb-3'>
                            <h2 className='fs-ss-36 text-philos fw-800 text-ss-black'>
                            {t('servicePages.webDevelopment.powerfulSolutionsTitle')}
                            </h2>
                        </div>
                            <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
                            {t('servicePages.webDevelopment.powerfulSolutionsDescription')}
                            </p>
                            <div className='px-lg-5'>
                            <img className='w-100' src={WebDev} alt="Web Dev"/>
                    </div>
                </Col>
            </Row>
        </div>
    </div>
    
    <section className="container-fluid pb-4">
      <div className='row justify-content-evenly align-items-center'>
        <div className="col-11 col-md-10">
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.webDevelopment.hierarchyDescription')}
             </p>
        </div>
        </div>
      </div>
    </section>
    

    <section className="container-fluid py-5 bg-ss-primary text-white">
      <div className='row justify-content-evenly align-items-center'>
        <div className="col-11 col-md-10">
         <div className=''>
             <div className='fs-ss-18 text-mulish fw-500 lh-1-8 d-flex align-items-center'>
             <div className=''>
             <ChevronRight className='me-2 fs-ss-18'/>
             </div>
             <div className=''>
              {t('servicePages.webDevelopment.clientSideCoding')}
              </div>
              </div>
             <div className='fs-ss-18 text-mulish fw-500 lh-1-8 d-flex align-items-center'>
             <div className=''>
             <ChevronRight className='me-2 fs-ss-18'/> 
             </div>
             <div className=''>
             {t('servicePages.webDevelopment.serverSideCoding')}
             </div>
             </div>
             <div className='fs-ss-18 text-mulish fw-500 lh-1-8 d-flex align-items-center'>
             <div className=''>
             <ChevronRight className='me-2 fs-ss-18'/> 
             </div>
             <div className=''>
             {t('servicePages.webDevelopment.databaseTechnology')}
             </div>
             </div>
        </div>
        </div>
      </div>
    </section>

    <section className="container-fluid py-4 py-lg-5">
      <div className='row justify-content-evenly align-items-center gy-4'>
        <div className="col-11 col-md-5">
          <img className='w-100' src={Img3} alt="" />
        </div>
        <div className="col-11 col-md-5">
        <div className='mb-lg-4 mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
             {t('servicePages.webDevelopment.trustedPartnersTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.webDevelopment.trustedPartnersDescription')}
             </p>
        </div>
        </div>
      </div>
    </section>
    <MiddleBannerSecondary
    Title={<> <div className='text-start'>{t('servicePages.webDevelopment.apiTitle')}</div></>}
    Para={<><div className='text-start'>{t('servicePages.webDevelopment.apiDescription')} <br/><br/> {t('servicePages.webDevelopment.developersDescription')}</div>
    <div className='pt-4'>
    <Link to="/packages" className="text-decoration-none text-white fs-ss-18 fw-500 border-2 border-white border py-2 px-3"> {t('servicePages.webDevelopment.viewPackages')} <ChevronRight className='fs-ss-22'/> </Link>
    </div>
    </>}
    />
    <div className='pt-4 pt-lg-0'/>
    <ImageBorderStyleRight
    Img={Img1}
    Title={t('servicePages.webDevelopment.uxUiTitle')}
    Para={t('servicePages.webDevelopment.uxUiDescription')}
    />
    
    <section className="container-fluid pt-4">
      <div className='row justify-content-evenly align-items-center'>
        <div className="col-11 col-md-9">
        <div className='mb-lg-4 mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
             {t('servicePages.webDevelopment.htmlCodingTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.webDevelopment.htmlCodingDescription')}
             </p>
        </div>
        </div>
      </div>
    </section>

    <section className="container-fluid pt-4">
      <div className='row justify-content-evenly align-items-center'>
        <div className="col-11 col-md-9">
        <div className='mb-lg-4 mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
             {t('servicePages.webDevelopment.cssCodingTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.webDevelopment.cssCodingDescription')}
             </p>
        </div>
        </div>
      </div>
    </section>
    <ImageBorderStyleLeft
    Img={Img2}
    Title={t('servicePages.webDevelopment.seoTitle')}
    Para={t('servicePages.webDevelopment.seoDescription')}
    />

<section className="container-fluid pt-4">
      <div className='row justify-content-evenly align-items-center'>
        <div className="col-11 col-md-9">
        <div className='mb-lg-4 mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
             {t('servicePages.webDevelopment.toolsTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.webDevelopment.toolsDescription')}
             </p>
        </div>
        </div>
      </div>
    </section>

    <section className="container-fluid py-4">
      <div className='row justify-content-evenly align-items-center'>
        <div className="col-11 col-md-9">
        <div className='mb-lg-4 mb-3'>
             <div className='fs-ss-36 text-philos fw-800 text-ss-black lh-sm'>
                {t('servicePages.webDevelopment.testingTitle')}
             </div>
         </div>
         <div className=''>
             <p className='fs-ss-16 text-mulish fw-500 text-ss-black lh-1-8'>
             {t('servicePages.webDevelopment.testingDescription')}
             </p>
        </div>
        </div>
      </div>
    </section>
    </section>
    </>
  )
}

export default WebDevelopment